
export const mergeMedicalOrganizations = (medicalOrganizations, organizationVaccines) => (
  organizationVaccines
    .map(vaccine => {
      const organizations = medicalOrganizations
        .filter(org => (vaccine.medicalOrganizationId === org.id))

      return {
        ...organizations[0],
        vaccines: vaccine.vaccines,
        vaccineId: vaccine.id,
        vaccineCreatedAt: vaccine.createdAt,
      }
    })
    .filter(org => org.vaccines.length > 0 && !!org.id)
)